import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from 'antd';
var FormInput = function (props) {
    return (_jsx(Form.Item, { label: props.label, name: props.name, className: "form-item body---14pt-R", rules: props.rules, hasFeedback: true, initialValue: props.initialValue, children: _jsx(Input, { className: "input-border", bordered: props.bordered, placeholder: props.placeHolder, onChange: props.onChange, addonAfter: props.addonAfter }) }));
};
export default FormInput;
